import { Component, Input, Output, EventEmitter, OnInit, SimpleChanges } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ClientService } from "src/app/services/clients/client.service";

import { BaseComponent } from "../../base.component";
import { MasterService } from "src/app/services/master/master.service";
import { NgForm } from "@angular/forms";
@Component({
  selector: "app-cb-clone-template-modal",
  templateUrl: "./cb-clone-template-modal.component.html",
  styleUrls: ["./cb-clone-template-modal.component.scss"],
})
export class CbCloneTemplateModalComponent  extends BaseComponent implements OnInit {
  @Input() templateData: any;
  @Input() modalTitle: string = '';
  @Input() isCloneModalOpen: boolean = false;
  @Output() closed = new EventEmitter<void>();
  @Output() refreshTemplateList = new EventEmitter<void>();

  templateName: string = '';
  templateSubject: string = '';
  domainID: number | null = null;
  journeyID: number | null = null;
  themesID: number[] = [];

  private templateID: number | null = null;

  domainData: any[] = [];
  jorneyType: any[] = [];
  themeList: any[] = [];
  formSubmitted: boolean = false;

  constructor(
    public master: MasterService,
    private spinner: NgxSpinnerService,
    private clientService: ClientService,
  ) {
    super();
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isCloneModalOpen'] && this.isCloneModalOpen && this.templateData) {
      this.initFormWithDefaults();
    }
  }

  private initFormWithDefaults() {
    this.templateID = this.templateData.template_id;
    this.templateName = this.templateData.template_name;
    this.templateSubject = this.templateData.template_subject;
    this.domainID = Number(this.templateData.domain_id);
    this.journeyID = Number(this.templateData.journey_id);
    this.themesID = (this.templateData.theme_id || []).map(Number);

    this.getBusinessDomain();
  }

  // ---------- STEP 1: DOMAIN ----------
  getBusinessDomain() {
    this.master.getBusinessDomain(100, 0, this.templateData.company_id).subscribe(
      (data) => {
        this.domainData = data.data.rows.map((d: any) => ({
          ...d,
          id: Number(d.id),
        }));

        if (this.domainID !== null && !this.domainData.some((d) => d.id === this.domainID)) {
          this.domainID = null;
        }

        if (this.domainID !== null) {
          this.getCompanyJourneyType();
        }
      },
      (error) => console.log(error),
    );
  }

  onDomainChange(event: any) {
    this.domainID = Number(event.value);
    this.journeyID = null;
    this.themesID = [];
    this.jorneyType = [];
    this.themeList = [];
    this.getCompanyJourneyType();
  }

  // ---------- STEP 2: JOURNEY ----------
  getCompanyJourneyType() {
    this.spinner.show();
    this.clientService.getAllJourney(this.templateData.company_id).subscribe(
      (data) => {
        if (data.status) {
          this.jorneyType = (data?.rows || []).sort((a: any, b: any) =>
            a.journey_name.localeCompare(b.journey_name),
          );

          if (this.journeyID !== null && !this.jorneyType.some((j) => j.journey_id === this.journeyID)) {
            this.journeyID = null;
          }

          if (this.journeyID !== null) {
            this.getThemeList();
          }
        } else {
          this.jorneyType = [];
        }
        this.spinner.hide();
      },
      (error) => {
        console.log(error);
        this.spinner.hide();
      },
    );
  }

  onJourneyChange(event: any) {
    this.journeyID = event.value;
    this.themesID = [];
    this.themeList = [];
    if (this.journeyID) {
      this.getThemeList();
    }
  }

    // ---------- STEP 3: THEME ----------
  getThemeList() {
    if (!this.journeyID) return;
    this.spinner.show();
    this.clientService
      .getAllThemeWithJourney(this.templateData.company_id, this.journeyID, this.domainID)
      .subscribe(
        (data) => {
          if (data.status) {
            this.themeList = (data?.rows || []).sort((a: any, b: any) =>
              a.theme_name.localeCompare(b.theme_name),
            );
            this.themesID = this.themesID.filter((id) =>
              this.themeList.some((t) => t.theme_id === id),
            );
          } else {
            this.themeList = [];
          }
          this.spinner.hide();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        },
      );
  }

  onThemeChange(event: any) {
    this.themesID = event.value;
  }

    // ---------- SUBMIT ----------
  submitClone(form?: NgForm) {
    this.formSubmitted = true;

    const isValid =
      this.templateName?.trim() &&
      this.templateSubject?.trim() &&
      this.domainID !== null &&
      this.journeyID !== null &&
      this.themesID?.length > 0;

    if (!isValid) {
      return;
    }

    const payload = {
      template_id: this.templateID,
      template_name: this.templateName.trim(),
      template_subject: this.templateSubject.trim(),
      company_id: this.templateData.company_id,
      domain_id: this.domainID,
      journey_id: this.journeyID,
      theme_id: this.themesID[0],
    };

    this.clientService.cloneEmailTemplate(payload).subscribe(
      (data) => {
        if (data.status) {
          this.toastrService.success(data.message);
        }
        this.refreshTemplateList.emit();
        this.closeModal();
      },
      (error) => {
        console.log(error);
        this.spinner.hide();
      },
    );
  }

  closeModal() {
    this.closed.emit();
  }
}
